var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    { class: { "md-input-invalid": _vm.showRequiredError } },
    [
      _c("label", { attrs: { for: "genre" } }, [_vm._v("Genres")]),
      _c(
        "md-select",
        {
          attrs: { id: "genre", name: "genre", multiple: _vm.multiple },
          on: { selected: _vm.onGenreSelected },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        _vm._l(_vm.genres, function(genre) {
          return _c("md-option", { key: genre, attrs: { value: genre } }, [
            _vm._v(_vm._s(_vm._f("uppercase")(genre)))
          ])
        }),
        1
      ),
      _vm.showRequiredError
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v("This field is required")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7906f2e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7906f2e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/genre/GenresFormSelector.vue
// module id = 884
// module chunks = 0